<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <page-header v-if="props.campaignId" class="vx-mb-6 lg:vx-mb-12">
            <template v-slot:subtitle>
                <a href="/messaging/campaigns"
                   class="!vx-no-underline !vx-text-sky-600 vx-text-base vx-font-normal">
                    <font-awesome-icon class="vx-mr-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Campaigns
                </a>
            </template>

            <slot name="header">{{ campaign.name }}</slot>
        </page-header>

        <div :class="{'vx-grid vx-grid-cols-12': props.campaignId}">
            <page-sidebar v-if="props.campaignId" :links="[
                {href: `/messaging/campaigns/${props.campaignId}`, label: 'Details'},
                {href: `/messaging/campaigns/${props.campaignId}/contacts`, label: 'Contacts'},
            ]"></page-sidebar>
            <slot></slot>
        </div>
    </form-container>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { onMounted } from 'vue';
import FormContainer from '~/components/general/FormContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import { useCampaignDetails } from './useCampaignDetails';

const props = defineProps({
    campaignId: {
        type: Number,
        required: false,
    },
});

const { campaign, loading, mount } = useCampaignDetails();

onMounted(() => {
    mount(props.campaignId);
});

</script>
